import unitName from './unitName'

let standardIndicators = [
  {
    label: 'Total Loads',
    labelSmall: 'Tot Loads',
    value: (data) => {
      return data.length || '0'
    }
  },
  {
    label: 'Total Film Usage',
    labelSmall: 'Tot F Usg',
    value: (data) => {
      return Math.round((data || []).map((r) => r.unw_len_act || 0).reduce((sum, v) => sum + v))
    }
  },
  {
    label: 'Total Film Weight',
    labelSmall: 'Tot F Wgt',
    value: (data) => {
      return Math.round((data || []).map((r) => r.film_wgt_tot || 0).reduce((sum, v) => sum + v))
    }
  }
]

export default [
  {
    name: 'Applied Stretch',
    id: 'applied_stretch',
    fields: [
      { name: 'Machine local time', key: 'date', type: 'timestamp', shared: true },
      { name: 'Actual %', type: 'number', precision: 2, key: 'strch_pct_act' },
      { name: 'Target %', type: 'number', precision: 2, key: 'strch_pct_targ' },
      { name: 'Upper Limit %', type: 'number', precision: 2, key: 'strch_pct_lim_high' },
      { name: 'Lower Limit %', type: 'number', precision: 2, key: 'strch_pct_lim_low' },
      { name: 'Alarm', key: 'strch_pct_alarm', type: 'boolean' }
    ],
    chart: {
      name: 'Applied Stretch Analysis',
      xAxis: {
        name: 'Date'
      },
      yAxis: {
        name: 'Stretch %'
      },
      series: [
        // If y value is > 500 display it as 0 on the graph
        { xKey: 'date', yKey: 'strch_pct_act', name: 'Actual', type: 'spline', zIndex: 1, yTransform: (v) => v > 500 ? 0 : v },
        { xKey: 'date', yKey: 'strch_pct_targ', name: 'Target', type: 'spline', zIndex: 1 },
        { xKey: 'date', yKey: ['strch_pct_lim_low', 'strch_pct_lim_high'], name: 'Limit', type: 'columnrange', zIndex: 0 }
      ]
    },
    indicators: standardIndicators
  },
  {
    name: 'Unwind Length',
    id: 'unwind_length',
    fields: [
      { name: 'Machine local time', key: 'date', type: 'timestamp', shared: true },
      { name: 'Actual', key: 'unw_len_act', type: 'number', precision: 1 },
      { name: 'Target', key: 'unw_len_targ', type: 'number', precision: 1 },
      { name: 'Upper Limit', key: 'unw_len_lim_high', type: 'number', precision: 1 },
      { name: 'Lower Limit', key: 'unw_len_lim_low', type: 'number', precision: 1 },
      { name: 'Alarm', key: 'unw_len_alarm', type: 'boolean' }
    ],
    chart: () => ({
      name: 'Unwind Analysis',
      xAxis: {
        name: 'Date'
      },
      yAxis: {
        name: 'Unwind Length in ' + unitName('feet')
      },
      series: [
        { xKey: 'date', yKey: 'unw_len_act', name: 'Actual', type: 'spline', zIndex: 1 },
        { xKey: 'date', yKey: 'unw_len_targ', name: 'Target', type: 'spline', zIndex: 1 },
        { xKey: 'date', yKey: ['unw_len_lim_low', 'unw_len_lim_high'], name: 'Limit', type: 'columnrange', zIndex: 0 }

      ]
    }),
    indicators: standardIndicators
  },
  {
    name: 'Revolutions',
    id: 'revolutions',
    fields: [
      { name: 'Machine local time', key: 'date', type: 'timestamp', shared: true },
      { name: 'Actual', key: 'rev_act', type: 'number', precision: 1 },
      { name: 'Target', key: 'rev_targ', type: 'number', precision: 1 },
      { name: 'Upper Limit', key: 'rev_lim_high', type: 'number', precision: 1 },
      { name: 'Lower Limit', key: 'rev_lim_low', type: 'number', precision: 1 },
      { name: 'Alarm', key: 'rev_alarm', type: 'boolean' }
    ],
    chart: {
      name: 'Revolutions',
      xAxis: {
        name: 'Date'
      },
      yAxis: {
        name: 'Revolutions'
      },
      series: [
        { xKey: 'date', yKey: 'rev_act', name: 'Actual', type: 'spline', zIndex: 1 },
        { xKey: 'date', yKey: 'rev_targ', name: 'Target', type: 'spline', zIndex: 1 },
        { xKey: 'date', yKey: ['rev_lim_low', 'rev_lim_high'], name: 'Limit', type: 'columnrange', zIndex: 0 }

      ]
    },
    indicators: standardIndicators
  },
  {
    name: 'Film Cost',
    id: 'film_cost',
    fields: [
      { name: 'Machine local time', key: 'date', type: 'timestamp', shared: true },
      { name: 'Film Cost', key: 'film_cost_tot', type: 'currency' }
    ],
    chart: {
      name: 'Film Cost',
      xAxis: {
        name: 'Date'
      },
      yAxis: {
        name: 'Total Cost in $'
      },
      series: [
        { xKey: 'date', yKey: 'film_cost_tot', name: 'Film Cost', type: 'spline' }
      ]
    },
    indicators: standardIndicators
  },
  {
    name: 'Film Weight',
    id: 'film_weight',
    fields: [
      { name: 'Machine local time', key: 'date', type: 'timestamp', shared: true },
      { name: 'Film Weight', key: 'film_wgt_tot', type: 'number', precision: 1 }
    ],
    chart: () => ({
      name: 'Film Weight',
      xAxis: {
        name: 'Date'
      },
      yAxis: {
        name: 'Total Weight in ' + unitName('ounces')
      },
      series: [
        { xKey: 'date', yKey: 'film_wgt_tot', name: 'Film Weight', type: 'spline' }
      ]
    }),
    indicators: standardIndicators
  }
]
